import React, {
  Fragment,
  useCallback,
  useEffect,
  useState,
  useMemo,
} from "react";
import Button from "../Button/Button";
import axios from "axios";
import { baseURL } from "../../constants/pathnames";
import { useSelector } from "react-redux";

const ModalRequestDetail = ({ onCancel, id, getdata }) => {
  const { token } = useSelector((state) => state.users);
  const header = useMemo(() => {
    const headers = {
      headers: {
        Authorization: `jwt ${token}`,
      },
    };
    return headers;
  }, [token]);
  const [loader, setLoader] = useState(false);
  console.log(id);

  const [data, setData] = useState({});
  // const [loading, setloading] = useState({});

  const gatData = useCallback(() => {
    debugger;
    axios
      .get(`${baseURL}product/panel/suggest/update/${id}/`, header)
      .then((res) => {
        console.log(res.data);
        setData(res.data);
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  }, [id, header]);
  useEffect(() => gatData(), [gatData]);

  useEffect(() => {
    const overlay = document.querySelector(".modal-overlay");
    const listener = (event) => {
      if (overlay) {
        onCancel();
        console.log(event);
      }
    };
    overlay.addEventListener("click", listener);
  });

  const handleOperation = (status) => {
    setLoader(true);
    const data = { offer_status: status };
    axios
      .patch(`${baseURL}product/panel/suggest/update/${id}/`, data, header)
      .then((res) => {
        console.log(res.data);
        gatData();
        getdata();
        // setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Fragment>
      <div
        style={{ zIndex: "1000000" }}
        className='fixed inset-0 overflow-y-auto '
        aria-labelledby='modal-title'
        role='dialog'
        aria-modal='true'
      >
        <div
          className='flex items-center  min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 transition-opacity ease-in duration-300'
          // transition-opacity ease-in duration-300
          style={{ transition: "opacity 0.25s ease" }}
        >
          <div
            className='fixed inset-0 bg-gray-500 bg-opacity-50  modal-overlay'
            aria-hidden='true'
            // ref={ref}
          ></div>

          <span
            className='hidden sm:inline-block sm:align-middle sm:h-screen'
            aria-hidden='true'
          >
            &#8203;
          </span>

          <div className='inline-block bg-white rounded-2xl overflow-hidden shadow-xl transform transition-all sm:my-8 align-middle sm:max-w-2xl w-full'>
            <div className='bg-white py-9'>
              <div className='max-w-xl mx-auto w-full p-3 md:p-0'>
                <img
                  className='m-2 absolute left-4 top-4'
                  src='/statics/images/close.svg'
                  width='16px'
                  height='16px'
                  alt='arrow'
                  onClick={() => {
                    onCancel();
                  }}
                />

                <>
                  <div className='text-lg'>مشاهده جزییات</div>

                  <div className='flex justify-center items-center text-sm font-semibold my-5'>
                    وضعیت:
                    {data?.offer_status === 3 ? (
                      <div className='color-yellow mx-1'>در انتظار تایید</div>
                    ) : data?.offer_status === 0 ? (
                      <div className='color-green2 mx-1'>تایید شده</div>
                    ) : data?.offer_status === 1 ? (
                      <div className='color-red mx-1'>لغو شده</div>
                    ) : (
                      ""
                    )}{" "}
                  </div>

                  {/* sender */}
                  <div className='my-10 border-b-2'>
                    <div className='my-3 text-right font-bold'>
                      درخواست دهنده
                    </div>
                    <div className='grid grid-cols-1 md:grid-cols-3  justify-between items-center'>
                      <div className='flex justify-start md:justify-center items-center'>
                        <div className='font-bold my-1 ml-1'>عنوان</div>
                        <div className='md:hidden'>{data?.offer_product}</div>
                      </div>

                      <div className='flex justify-start md:justify-center  items-center'>
                        <div className='font-bold my-1 ml-1'>
                          نام و نام خانوادگی
                        </div>
                        <div className='md:hidden'>
                          {data?.offer_product_user}
                        </div>
                      </div>

                      <div className='flex justify-start md:justify-center items-center'>
                        <div className='font-bold my-1 ml-1'>دسته بندی</div>
                        <div className='md:hidden'>{data?.offer_category}</div>
                      </div>
                    </div>

                    <div className='hidden md:grid grid-cols-3 justify-between items-center p-2 shadow rounded-xl'>
                      <div className=''>{data?.offer_product}</div>

                      <div className=''>{data?.offer_product_user}</div>

                      <div className=''>{data?.offer_category}</div>
                    </div>

                    <div>
                      <div className='my-3 text-right font-bold'>
                        تصویر مربوط به کالا{" "}
                      </div>
                      <img
                        className='my-3 p-1  w-20 h-20 rounded-xl border-dashed border-2'
                        src={data?.offer_image?.image}
                        width='100px'
                        height='100px'
                        alt='arrow'
                      />
                    </div>
                  </div>

                  {/* receiver */}
                  <div className='my-10'>
                    <div className='my-3 text-right font-bold'>
                      درخواست گیرنده
                    </div>

                    <div className='grid grid-cols-1 md:grid-cols-3  justify-between items-center'>
                      <div className='flex justify-start md:justify-center items-center'>
                        <div className='font-bold my-1 ml-1'>عنوان</div>
                        <div className='md:hidden'>
                          {data?.original_product}
                        </div>
                      </div>

                      <div className='flex justify-start md:justify-center  items-center'>
                        <div className='font-bold my-1 ml-1'>
                          نام و نام خانوادگی
                        </div>
                        <div className='md:hidden'>
                          {data?.original_product_user}
                        </div>
                      </div>

                      <div className='flex justify-start md:justify-center items-center'>
                        <div className='font-bold my-1 ml-1'>دسته بندی</div>
                        <div className='md:hidden'>
                          {data?.original_category}
                        </div>
                      </div>
                    </div>

                    <div className='hidden md:grid grid-cols-3 justify-between items-center p-2 shadow rounded-xl'>
                      <div className=''>{data?.original_product}</div>

                      <div className=''>{data?.original_product_user}</div>

                      <div className=''>{data?.original_category}</div>
                    </div>

                    <div>
                      <div className='my-3 text-right font-bold'>
                        تصویر مربوط به کالا{" "}
                      </div>
                      <img
                        className='my-3 p-1  w-20 h-20 rounded-xl border-dashed border-2'
                        src={data?.original_image?.image}
                        width='100px'
                        height='100px'
                        alt='arrow'
                      />
                    </div>
                  </div>

                  <div className='flex justify-center items-center gap-4'>
                    {data?.offer_status === 0 && (
                      <Button
                        title='پایان درخواست'
                        backgroundColor='#88cf4e'
                        borderColor='#88cf4e'
                        color='#fff'
                        borderWidth='2px'
                        margin='0'
                        maxHeight='40px'
                        maxWidth='150px'
                        onClick={() => {
                          handleOperation(2);
                        }}
                        // loading={loader}
                      />
                    )}

                    {(data?.offer_status === 0 || data?.offer_status === 3) && (
                      <Button
                        title='لغو درخواست'
                        margin='0'
                        backgroundColor='#cf4e4e'
                        maxWidth='150px'
                        maxHeight='40px'
                        onClick={() => {
                          handleOperation(1);
                        }}
                        loading={loader}
                      />
                    )}
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ModalRequestDetail;
